import request from '@/utils/request'

// 获取点位设备列表
export const getFactoryDeviceList = (data) => {
    return request({
        url: '/heating/monitor_data/lists',
        params: data
    })
}
